<template lang="html">
  <div class="si">
    <img class="banner" :src="`${pagebase}/static/img/si/banner.png`" alt="">
    <img class="modNo1" :src="`${pagebase}/static/img/si/modNo1.png`" alt="">
    <img class="modNo2" :src="`${pagebase}/static/img/si/modNo2.png`" alt="">
    <div class="swiper-container swiperConNo1">
      <div class="swiper-wrapper swiperChildNo1">
        <div class="swiper-slide swiperSlideNo1">
          <img :src="`${pagebase}/static/img/si/swiperNo1_1.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo1">
          <img :src="`${pagebase}/static/img/si/swiperNo1_2.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo1">
          <img :src="`${pagebase}/static/img/si/swiperNo1_3.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo1">
          <img :src="`${pagebase}/static/img/si/swiperNo1_4.png`" alt="">
        </div>
      </div>
    </div>
    <img class="modNo3" :src="`${pagebase}/static/img/si/modNo3.png`" alt="">
    <img class="course" :src="`${pagebase}/static/img/si/courseNo1.png`" alt="">
    <img class="course" :src="`${pagebase}/static/img/si/courseNo2.png`" alt="">
    <img class="course" :src="`${pagebase}/static/img/si/courseNo3.png`" alt="">
    <img class="course" :src="`${pagebase}/static/img/si/courseNo4.png`" alt="">
    <img class="modNo5" :src="`${pagebase}/static/img/si/modNo5.png`" alt="">
    <img class="modNo6" :src="`${pagebase}/static/img/si/modNo6.png`" alt="">
    <div class="swiper-container swiperConNo2">
      <div class="swiper-wrapper swiperChildNo2">
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_1.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_2.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_3.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_4.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_5.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo2">
          <img :src="`${pagebase}/static/img/si/swiperNo2_6.png`" alt="">
        </div>
      </div>
    </div>
    <img class="modNo7" :src="`${pagebase}/static/img/si/modNo7.png`" alt="">
    <div class="swiper-container swiperConNo3">
      <div class="swiper-wrapper swiperChildNo3">
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_1.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_2.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_3.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_4.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_5.png`" alt="">
        </div>
        <div class="swiper-slide swiperSlideNo3">
          <img :src="`${pagebase}/static/img/si/swiperNo3_6.png`" alt="">
        </div>
      </div>
    </div>
    <img class="modNo8" :src="`${pagebase}/static/img/si/modNo8.png`" alt="">
    <img :src="`${pagebase}/static/img/si/consulting.png`" alt="" class="consultingIcon" @click="arrangeShow">
    <div class="footerMod">
      <div class="signUp">
        <div class="signUpPrice">
          <p class="originalCost">早鸟价：<span>{{activityCon.cash_price}}</span></p>
          <p class="currentPrice">原价：<s>{{activityCon.cash_origin_price}}</s></p>
        </div>
        <div class="signUpBtn" @click="signUp">立即报名</div>
      </div>
    </div>

    <div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
      <div class="consult_alert_con">
        <div class="consult_alert_ma">
          <p>保存识别二维码</p>
          <p>发送“仿真”咨询入营</p>
          <img class="" :src="`${pagebase}/static/img/si/qrCode.png`" alt="">
        </div>
        <div class="consult_close_btn">
          <img class="" :src="`${pagebase}/static/img/si/close.png`" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper/swiper-bundle.min.js'
  import 'swiper/swiper-bundle.min.css'
  import { pagebase } from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  // 百度
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showStat();
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
        this.getOneSwiper();
        this.getTwoSwiper();
        this.getThreeSwiper();
      },
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },

      arrangeShow() {
        this.arrangeshow = true;
      },

      consultClose() {
        this.arrangeshow = false;
      },

      getOneSwiper() {
        new Swiper(".swiperConNo1", {
          slidesPerView: "auto",
          spaceBetween: 8,
          observer: true,
          observeParents: true,
        });
      },

      getTwoSwiper() {
        new Swiper(".swiperConNo2", {
          slidesPerView: "auto",
          spaceBetween: 8,
          observer: true,
          observeParents: true,
          centeredSlides: true,
          loop: true,
        });
      },

      getThreeSwiper() {
        new Swiper(".swiperConNo3", {
          slidesPerView: "auto",
          spaceBetween: 8,
          observer: true,
          observeParents: true,
          centeredSlides: true,
          loop: true,
        });
      },

      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=emc' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'emc',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .si {
    background-color: #0D2A48;
    position: relative;
  }

  .banner {
    width: 100%;
  }

  .modNo1 {
    width: 100%;
  }

  .modNo2 {
    width: 100%;
  }

  .swiperConNo1 {
    box-sizing: border-box;
    padding: 0 .8rem;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-top: -2rem;
  }

  .swiperChildNo1 {
    display: flex;
    justify-content: flex-start;
  }

  .swiperSlideNo1 {
    width: 70%;
  }

  .swiperSlideNo1 img {
    width: 100%;
  }

  .modNo3 {
    margin-top: 4rem;
    width: 100%;
  }
  
  .course{
    width: 100%;
  }

  .modNo4 {
    width: 100%;
  }

  .modNo5 {
    width: 100%;
  }

  .modNo6 {
    width: 100%;
  }

  .swiperConNo2 {
    margin-top: -13rem;
  }

  .swiperSlideNo2 {
    width: 15rem;
    height: 11rem;
  }

  .swiperSlideNo2 img {
    width: 100%;
    border-radius: .8rem;
    box-shadow: .1rem .4rem .5rem rgba(0, 0, 0, 0.3);
  }

  .modNo7 {
    margin-top: 1rem;
    width: 100%;
  }

  .swiperConNo3 {
    margin-top: -5.5rem;
  }

  .swiperSlideNo3 {
    width: 25.8rem;
    height: 24rem;
  }

  .swiperSlideNo3 img {
    width: 100%;
    border-radius: .8rem;
    box-shadow: .2rem .8rem .8rem rgba(0, 0, 0, 0.3);
  }

  .modNo8 {
    margin-top: 2rem;
    width: 100%;
  }

  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: linear-gradient(to bottom, rgba(13, 43, 72, 0.8), rgba(13, 43, 72, 1));
    z-index: 10;
  }

  .consultingIcon {
    width: 7.2rem;
    height: 7.2rem;
    position: fixed;
    right: 1rem;
    bottom: 8.5rem;
    z-index: 10;
  }

  .signUp {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(13, 43, 72, 0.01);
    box-sizing: border-box;
    padding: 0 3rem;
    margin-top: 1rem;
  }

  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }

  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }

  .originalCost span {
    color: #FFC851;
  }

  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }

  .currentPrice span {
    color: #FFFFFF;
  }

  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #B68043;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .consult_alert {
    display: none;
    z-index: 11;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .consult_alert_con {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -14rem;
    margin-left: -14rem;
    width: 28rem;
    height: 28rem;
    background-color: #F3F7FC;
    border-radius: 1rem;
  }

  .consult_alert_ma {
    height: 100%;
    display: flex;
    font-size: 1.8rem;
    font-weight: 600;
    color: #080943;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .consult_alert_ma img {
    width: 15rem;
    height: 15rem;
  }

  .arrangeshow {
    display: block;
  }

  .consult_close_btn {
    margin-top: .5rem;
    display: flex;
    justify-content: center;
  }

  .consult_close_btn img {
    width: 3.8rem;
    height: 3.8rem;
  }

  @media (min-width: 751px) {
    .consultingIcon{
      right: 50%;
      margin-right: -375px;
    }
    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>
